import { render, staticRenderFns } from "./work-queue.html?vue&type=template&id=8dc20d3c&scoped=true&"
import script from "./work-queue.ts?vue&type=script&lang=js&"
export * from "./work-queue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc20d3c",
  null
  
)

export default component.exports